import React from 'react';

export default class RestaurantLoading extends React.PureComponent {
  render() {
    return (
      <div>
        <div className="container">
          <div className="row">
            <div className="col-sm-9">
              <div
                className="rest-breadcrumb white-bg d-flex justify-content-between align-items-center"
                style={{marginTop: '-57px', marginBottom: '0', height: '50px'}}
              >
                <p
                  className="spinner-element animate"
                  style={{width: '43px', height: '16px'}}
                />
                <p
                  className="spinner-element animate"
                  style={{width: '88px', height: '16px'}}
                />
                <p
                  className="spinner-element animate"
                  style={{width: '43px', height: '16px'}}
                />
              </div>

              <div className="restaurant-detail">
                <div className="head">
                  <p
                    className="spinner-element animate"
                    style={{width: '100%', height: '100px'}}
                  />
                  <div className="button d-flex justify-content-between align-items-center">
                    <icon className="icon icon-back-white"/>
                    <icon className="icon icon-favorite-add"/>
                  </div>
                </div>
                <div className="detail white-bg">
                  <p
                    className="spinner-element animate"
                    style={{width: '152px', height: '16px', marginBottom: '4px'}}
                  />
                  <p
                    className="spinner-element animate"
                    style={{width: '39px', height: '16px', marginBottom: '4px'}}
                  />
                  <div className="d-flex justify-content-between align-items-center ">
                    <p
                      className="spinner-element animate"
                      style={{width: '118px', height: '16px'}}
                    />
                    <div className="comments" style={{marginTop: '-15px'}}>
                  <span className="avg-score">
                    <span
                      className="spinner-element animate"
                      style={{
                        display: 'block',
                        borderRadius: '50%',
                        width: '27px',
                        height: '27px',
                      }}
                    />
                  </span>
                    </div>
                  </div>
                </div>

                <div className="white-bg mt-10px" style={{padding: '8px 15px'}}>
                  <p
                    className="spinner-element animate"
                    style={{width: '152px', height: '16px', margin: '0 auto'}}
                  />
                </div>

                <div className="white-bg mt-10px padding-box d-flex visible-xs">
                  <p
                    className="spinner-element animate"
                    style={{width: '16px', height: '16px', marginRight: '10px'}}
                  />
                  <div>
                    <p
                      className="spinner-element animate"
                      style={{
                        width: '118px',
                        height: '16px',
                        marginBottom: '7px',
                      }}
                    />
                    <p
                      className="spinner-element animate"
                      style={{width: '100%', height: '16px'}}
                    />
                  </div>
                </div>

                <div className="white-bg mt-10px visible-xs" style={{padding: '8px 15px'}}>
                  <p
                    className="spinner-element animate"
                    style={{width: '118px', height: '16px'}}
                  />
                </div>

                <div className="detail-tab hide-xs" style={{position:'relative',top:'10px' }}>
                  <ul>
                    <li>
                      <a href="javascript:void(0)" style={{ background:'#fff'}}>
                        <p className="spinner-element animate"  style={{width: '57px', height: '16px'}}></p>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)" >
                        <p className="spinner-element animate"  style={{width: '57px', height: '16px'}}></p>
                      </a>
                    </li>
                    <li>
                      <a href="javascript:void(0)">
                        <p className="spinner-element animate"  style={{width: '57px', height: '16px'}}></p>
                      </a>
                    </li>
                  </ul>
                </div>

                <div className="white-bg mt-10px" style={{padding: '14px 15px'}}>
                  <p
                    className="spinner-element animate"
                    style={{width: '118px', height: '16px', marginBottom: '10px'}}
                  />

                  <div className="d-flex justify-content-between">
                    <p
                      className="spinner-element animate"
                      style={{width: '118px', height: '16px'}}
                    />
                    <div style={{marginBottom: '7px', marginTop: '-20px'}}>
                      <p
                        className="spinner-element animate"
                        style={{
                          width: '31px',
                          height: '16px',
                          marginBottom: '2px',
                        }}
                      />
                      <p
                        className="spinner-element animate"
                        style={{width: '43px', height: '16px'}}
                      />
                    </div>
                  </div>
                  <p
                    className="spinner-element animate mt-10px"
                    style={{width: '228px', height: '16px', marginBottom: '25px'}}
                  />

                  <div
                    className="d-flex justify-content-between"
                    style={{marginBottom: '7px'}}
                  >
                    <p
                      className="spinner-element animate"
                      style={{width: '118px', height: '16px'}}
                    />
                    <p
                      className="spinner-element animate"
                      style={{width: '47px', height: '16px'}}
                    />
                  </div>
                  <p
                    className="spinner-element animate mt-10px"
                    style={{width: '228px', height: '16px', marginBottom: '25px'}}
                  />
                  <div
                    className="d-flex justify-content-between"
                    style={{marginBottom: '7px'}}
                  >
                    <p
                      className="spinner-element animate"
                      style={{width: '118px', height: '16px'}}
                    />
                    <p
                      className="spinner-element animate"
                      style={{width: '47px', height: '16px'}}
                    />
                  </div>
                  <p
                    className="spinner-element animate mt-10px"
                    style={{width: '228px', height: '16px', marginBottom: '5px'}}
                  />
                  <p
                    className="spinner-element animate mt-10px"
                    style={{width: '228px', height: '16px', marginBottom: '5px'}}
                  />
                  <p
                    className="spinner-element animate mt-10px"
                    style={{width: '228px', height: '16px', marginBottom: '5px'}}
                  />
                </div>
              </div>
            </div>

            <div className="col-sm-3 sidebar right-sidebar mt-10px hide-xs">
              <div className=" ">
                <div className="white-bg profile-bar">
                  <div className="d-flex align-items-center">
                    <div className="img spinner-element animate"
                         style={{width: '40px', height: '40px', borderRadius: '6px'}}></div>
                    <div>
                      <p
                        className="spinner-element animate mt-10px"
                        style={{width: '104px', height: '16px', marginBottom: '5px'}}
                      />
                      <p
                        className="spinner-element animate mt-10px"
                        style={{width: '104px', height: '16px'}}
                      />
                    </div>
                  </div>
                </div>
                <div className="delivery-small" style={{padding: 0}}>
                  <div className="d-flex align-items-center">
                    <p
                      className="spinner-element animate"
                      style={{width: '100%', height: '16px'}}
                    />
                  </div>
                </div>
                <div className="white-bg basket-body">
                  <div style={{padding: '15px'}}>
                    <p
                      className="spinner-element animate"
                      style={{width: '100%', height: '16px', marginBottom: '5px'}}
                    />

                    <div className="mt-10px">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <p
                            className="spinner-element animate"
                            style={{width: '61px', height: '16px'}}
                          />
                        </div>
                        <div className="d-flex align-items-center">
                          <p
                            className="spinner-element animate"
                            style={{width: '15px', height: '15px', borderRadius: '50%', marginRight: '10px'}}
                          />
                          <p
                            className="spinner-element animate"
                            style={{width: '38px', height: '16px'}}
                          />
                          <p
                            className="spinner-element animate"
                            style={{width: '10px', height: '10px', borderRadius: '50%', marginLeft: '10px'}}
                          />
                        </div>
                      </div>
                      <div className="mt-10px">
                        <p
                          className="spinner-element animate"
                          style={{width: '80%', height: '16px'}}
                        />
                        <p
                          className="spinner-element animate mt-10px"
                          style={{width: '71px', height: '16px'}}
                        />
                      </div>

                    </div>

                    <div className="mt-10px">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <p
                            className="spinner-element animate"
                            style={{width: '61px', height: '16px'}}
                          />
                        </div>
                        <div className="d-flex align-items-center">
                          <p
                            className="spinner-element animate"
                            style={{width: '15px', height: '15px', borderRadius: '50%', marginRight: '10px'}}
                          />
                          <p
                            className="spinner-element animate"
                            style={{width: '38px', height: '16px'}}
                          />
                          <p
                            className="spinner-element animate"
                            style={{width: '10px', height: '10px', borderRadius: '50%', marginLeft: '10px'}}
                          />
                        </div>
                      </div>
                      <div className="mt-10px">
                        <p
                          className="spinner-element animate"
                          style={{width: '80%', height: '16px'}}
                        />
                        <p
                          className="spinner-element animate mt-10px"
                          style={{width: '71px', height: '16px'}}
                        />
                      </div>

                    </div>

                    <div className="mt-10px">
                      <div className="d-flex justify-content-between align-items-center">
                        <div>
                          <p
                            className="spinner-element animate"
                            style={{width: '61px', height: '16px'}}
                          />
                        </div>
                        <div className="d-flex align-items-center">
                          <p
                            className="spinner-element animate"
                            style={{width: '15px', height: '15px', borderRadius: '50%', marginRight: '10px'}}
                          />
                          <p
                            className="spinner-element animate"
                            style={{width: '38px', height: '16px'}}
                          />
                          <p
                            className="spinner-element animate"
                            style={{width: '10px', height: '10px', borderRadius: '50%', marginLeft: '10px'}}
                          />
                        </div>
                      </div>
                      <div className="mt-10px">
                        <p
                          className="spinner-element animate"
                          style={{width: '80%', height: '16px'}}
                        />
                        <p
                          className="spinner-element animate mt-10px"
                          style={{width: '80%', height: '16px'}}
                        />

                        <p
                          className="spinner-element animate mt-10px"
                          style={{width: '117px', height: '16px'}}
                        />
                      </div>


                      <div  style={{borderTop:'1px solid #bec2c9', padding:'10px 0'}} className="mt-10px d-flex align-items-center justify-content-between">
                        <p
                          className="spinner-element animate mt-10px"
                          style={{width: '43px', height: '16px'}}
                        />
                        <p
                          className="spinner-element animate mt-10px"
                          style={{width: '43px', height: '16px'}}
                        />
                      </div>

                    </div>

                  </div>
                </div>
                <a href="/checkout" className="btn btn-gray spinner-element animate">&nbsp;</a></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
